import { Announcement, QueuedAnnouncement } from '../types';

/**
 * Announcement queue manager
 * Handles prioritization and display order of announcements
 */
export class AnnouncementQueue {
    private queue: QueuedAnnouncement[] = [];
    private currentIndex: number = 0;

    constructor(announcements: Announcement[]) {
        this.buildQueue(announcements);
    }

    private buildQueue(announcements: Announcement[]): void {
        // Filter out 'none' boost type announcements
        const boostedAnnouncements = announcements.filter((a) => a.boost_type !== 'none');

        // Sort by priority: popup > topbar > toast
        const priorityMap: { [key: string]: number } = {
            full_page_popup: 3,
            top_bar: 2,
            toast_notification: 1,
            none: 0,
        };

        this.queue = boostedAnnouncements
            .map((announcement) => ({
                announcement,
                priority: priorityMap[announcement.boost_type] || 0,
            }))
            .sort((a, b) => b.priority - a.priority);
    }

    public hasNext(): boolean {
        return this.currentIndex < this.queue.length;
    }

    public getNext(): Announcement | null {
        if (!this.hasNext()) {
            return null;
        }

        const queued = this.queue[this.currentIndex];
        this.currentIndex++;

        return queued.announcement;
    }

    public reset(): void {
        this.currentIndex = 0;
    }

    public size(): number {
        return this.queue.length;
    }

    public remaining(): number {
        return Math.max(0, this.queue.length - this.currentIndex);
    }
}
